<div id="results" class="booking">
  <div id="pageWrap" class="singleHotel">
    <div id="headerSorting" class="flex jc-end">
      <button class="booking__back-btn" (click)="goBack()">
        < Back to Property</button>
    </div>
    <div class="booking__title flex jc-c">
      <h1>Ready to book!</h1>
      <img src="../../../assets/img/highlight.svg" alt="Yellow Highlighted Line">
    </div>
    <section class="grid-1col">
      <div class="guest-details">
        <div class="guestForm" *ngIf="guestDetails && guestDetails.length>0">
          <form class="form flex-column">
            <div>
              <h4 class="form__title">Guest details</h4>
              <p class="form__desc">Please give us the name of one of the people staying in this room.</p>
            </div>
            <div class="grid-2col gap-1 mb-3">
              <div class="form__container">
                <label class="form__label">First name</label>
                <input title="First Name" class="form__input" type="text" [attr.disabled]="guestDeatailsDisabled? '': null"
                  [(ngModel)]="guestDetails[0].firstName" [value]="guestDetails[0].firstName"
                  [ngModelOptions]="{standalone: true}">
              </div>
              <div class="form__container">
                <label class="form__label">Last name</label>
                <input title="Last Name" class="form__input" type="text" [attr.disabled]="guestDeatailsDisabled? '': null"
                  [(ngModel)]="guestDetails[0].lastName" [value]="guestDetails[0].lastName"
                  [ngModelOptions]="{standalone: true}">
              </div>
            </div>
            <div class="guest-details-row mb-3">
              <div class="form__container">
                <label class="form__label">Email</label>
                <input title="Email" class="form__input" type="email" [attr.disabled]="guestDeatailsDisabled? '': null"
                  [(ngModel)]="guestDetails[0].email" [value]="guestDetails[0].email"
                  [ngModelOptions]="{standalone: true}">
              </div>
            </div>
            <div class="grid-2col gap-1 mb-3">
              <div class="form__container">
                <label class="form__label">Country</label>
                <div id="countries" class="select">
                  <select title="Select Country" class="form__input" [attr.disabled]="guestDeatailsDisabled? '': null"
                    [(ngModel)]="selectedValue" [ngModelOptions]="{standalone: true}">
                    <option *ngFor="let c of countries" [ngValue]="c">{{c}}</option>
                  </select>
                </div>
              </div>
              <div class="form__container">
                <label class="form__label">Mobile</label>
                <input title="Enter Mobile Phone" class="form__input" [attr.disabled]="guestDeatailsDisabled? '': null"
                  [(ngModel)]="guestDetails[0].phone" [value]="guestDetails[0].phone"
                  [ngModelOptions]="{standalone: true}" type="tel" value="">
              </div>
            </div>
            <div class="guest-details-row">
              <div class="form__container">
                <label class="form__label">Estimated Time of Arrival (optional)</label> <br>
              </div>
              <div class="estimatedTimes">
                <div id="arrival" class="select">
                  <select title="Select Estimated Time of Arrival" id="etaVal" class="form__input" [attr.disabled]="guestDeatailsDisabled? '': null">
                    <option *ngFor="let time of estimatedTimes; let i = index"
                      value=" {{estimatedTimes[i]}}- {{estimatedEndTimes[i+1]}}">
                      {{estimatedTimes[i]}}- {{estimatedEndTimes[i+1]}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="booking-payment-details">
        <app-payment-details [visibility]="true" [type]="''" (updateCreditCardDetails)="saveCreditCardDetails($event)">
        </app-payment-details>
      </div>
      <img class="booking__img" src="../../../assets/img/happy-woman.svg"
        alt="Illustration of a happy and cheerful woman">
    </section>

    <app-booking-info *ngIf="getSelectedRooms()" [type]="'booking'" [facilities]="getFacilitiesTab()"
      [languages]="getLanguages()" [checkinInfo]="getCheckin()" [pricingPolicy]="getPricingPolicy()"
      [bookingRequest]="this.bookingContainer.requestForSearch" [hotelInfo]="getHotelInfo()"
      [rooms]="getSelectedRooms()" [roomsToShow]="getFinalRooms()" [mapInformation]="getMapInfo()"
      [cards]="getCardsAccepted()" [guestDetails]="getGuestDetails()" [offerNote]="getOfferNote()"
      (bookNowEv)=prepareForBooking($event) [finalWishes]="getFinalWishes()">
    </app-booking-info>
  </div>
</div>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  >
  <p style="font-size: 20px; color: white;">Booking...</p>
</ngx-spinner>